import useReveal from '@/hooks/useReveal';
import shared from '@/styles/public.module.css';
import styles from './NeverPaySection.module.css';

const ITEMS = [
  {
    title: 'Nothing if you lose',
    body: "Funding is non-recourse. If your case doesn't win, the funder absorbs it. You keep the money.",
  },
  {
    title: 'No monthly payments',
    body: 'Nothing is due while your case is open. Repayment happens once, out of the settlement.',
  },
  {
    title: 'No credit check',
    body: "Your credit score and your job aren't part of this. The case is what's being reviewed.",
  },
  {
    title: 'No fee to apply',
    body: 'Applying, getting verified, and reading your offers costs nothing. Walk away at any point.',
  },
];

const NeverPaySection = () => {
  const ref = useReveal(shared.rv, shared.revealed);

  return (
    <section className={shared.section} ref={ref} data-testid="never-pay-section">
      <div className={shared.wrap}>
        <div className={`${shared.secHead} ${shared.rv}`}>
          <span className={shared.eyebrow}>The catch, or the lack of one</span>
          <h2>What you never pay</h2>
        </div>

        <div className={styles.grid}>
          {ITEMS.map((item) => (
            <div key={item.title} className={`${styles.card} ${shared.rv}`}>
              <div className={styles.mark} aria-hidden="true">
                ✕
              </div>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NeverPaySection;
